import React, { useEffect, useState } from "react";
import { getSQLReportData } from "../../services/reports_services";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ReportsPage = ({ history }) => {
  const [reports, setReports] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const loadReports = (pageNumber) => {
    setLoading(true);
    getSQLReportData(pageNumber).then((data) => {
      setReports(data.results);
      setTotalPages(data.total_pages);
      setLoading(false);
    });
  };

  useEffect(() => {
    loadReports(page);
  }, [page]);

  const renderPagination = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setPage(i)}
          style={{
            ...buttonStyle,
            backgroundColor: i === page ? "#2A9D8F" : "#fff",
            color: i === page ? "#fff" : "#2A9D8F",
          }}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <div className="p-3 d-flex flex-column justify-center align-center">
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h4>Relatórios SQL</h4>
        <Link to="/reports/sql/new" className="w-50 btn btn-primary">
          Adicionar Relatório
        </Link>
      </div>

      <div style={gridStyle}>
        {loading && <p>Carregando...</p>}
        {!loading &&
          reports.map((report) => (
            <div key={report.id} className="w-100 report-card p-3">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ color: "#5f5f5f", textTransform: "capitalize" }}>
                  <Link
                    style={{ color: "#000000" }}
                    to={`/reports/sql/view/${report.id}`}
                  >
                    {report.name}
                  </Link>
                </h5>
                <FontAwesomeIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => history.push(`/reports/sql/${report.id}`)}
                  icon="fa-solid fa-pen-to-square"
                />
              </div>
            </div>
          ))}
      </div>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {renderPagination()}
      </div>
    </div>
  );
};

export default ReportsPage;

const gridStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  gap: "10px",
  marginTop: "20px",
};

const buttonStyle = {
  padding: "6px 12px",
  borderRadius: "50%",
  border: "1px solid #ccc",
  margin: "0 4px",
  cursor: "pointer",
};
